import React from "react"; // Replace 'your-ui-library' with the actual UI library you are using
import { useNavigate } from "react-router-dom";
import Button from "./Button";
import { Icon } from "../Component";
const BackButton = ({ cancel, backUrl }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (backUrl) {
      navigate(backUrl);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <Button
        color="light"
        type="button"
        outline
        className="bg-white d-none d-sm-inline-flex"
        onClick={handleGoBack}
      >
        {!cancel ? (
          <>
            <Icon name="arrow-left" />
            <span>Back</span>
          </>
        ) : (
          "Cancel"
        )}
      </Button>
    </>
  );
};

export default BackButton;
